<template>
  <div>
    <el-dialog
      ref="addEditViewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h500_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
    >
      <el-form
        ref="dialogAddEditViewForm"
        :model="dialogAddEditViewForm"
        :rules="eventType==='view' ? null : dialogAddEditViewFormRules"
        class="add-edit-view-form"
        @submit.native.prevent
      >
        <div class="modal-box">
          <h3 class="modal-title">
            基础信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  label="所属省区"
                  prop="provinceId"
                >
                  <el-select
                    v-if="eventType !== 'view'"
                    v-model="dialogAddEditViewForm.provinceId"
                    filterable
                    clearable
                    placeholder="请选择省区"
                    style="width:100%"
                    @change="handleProvinceChange"
                  >
                    <el-option
                      v-for="item in provinceOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  <el-input
                    v-else
                    v-model="dialogAddEditViewForm.provinceName"
                    disabled
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  label="档位分组名称"
                  prop="name"
                >
                  <el-input
                    v-model="dialogAddEditViewForm.name"
                    maxlength="64"
                    placeholder="请输入市场报告档位分组名称"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="排序字段"
                  prop="sortNum"
                >
                  <el-input-number
                    v-model="dialogAddEditViewForm.sortNum"
                    :min="1"
                    :max="999"
                    :precision="0"
                    :step="1"
                    :controls="false"
                    style="width: 100%;"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-form-item
                label="包含的终端档位"
                prop="levelIdArray"
              >
                <el-checkbox-group
                  v-if="eventType !== 'view'"
                  v-model="dialogAddEditViewForm.levelIdArray"
                  size="small"
                >
                  <el-col
                    v-for="(item, index) in levelOptions"
                    :key="'level_' + index"
                    :span="2"
                  >
                    <el-checkbox-button
                      :label="item.id"
                      style="width: 100%;"
                    >
                      {{ item.name }}
                    </el-checkbox-button>
                  </el-col>
                </el-checkbox-group>

                <div
                  v-else
                  class="level-tag"
                >
                  <el-col
                    v-for="(item, index) in dialogAddEditViewForm.levelNameArray"
                    :key="'level_name_' + index"
                    :span="2"
                  >
                    <el-tag
                      type="primary"
                      size="medium"
                      effect="dark"
                      style="width: 100%; text-align: center;"
                    >
                      {{ item }}
                    </el-tag>
                  </el-col>
                </div>
              </el-form-item>
            </el-row>
          </div>
        </div>

        <div class="modal-box">
          <h3 class="modal-title">
            备注信息
          </h3>
          <div class="modal-row-box">
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item prop="remark">
                  <el-input
                    v-model="dialogAddEditViewForm.remark"
                    type="textarea"
                    placeholder="备注"
                    maxlength="128"
                    :disabled="eventType==='view'"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-form>

      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          v-if="eventType!=='view'"
          type="primary"
          @click="handleSave"
        >
          保存
        </el-button>
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

// dialog 拖拽
import dialogDragMixin from '@/mixin/dialogDragMixin'
// API
import { listAreaApi } from '@/api/v2/area';
import { listStoreLevelSettingApi } from '@/api/v2/storeLevelSetting';
import { saveMarketReportLevelGroupApi, viewMarketReportLevelGroupApi } from '@/api/v2/marketReportLevelGroup';

export default {
  components: {},
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      dialogAddEditViewForm: {},
      dialogAddEditViewFormRules: {
        provinceId: [{ required: true, message: '请选择所属省区', trigger: 'change' }],
        name: [{ required: true, message: '请输入报告档位分组名称', trigger: 'blur' }, { max: 64, message: '最多输入64个字符', trigger: 'blur' }],
        levelIdArray: [{ required: true, message: '请选择分组包含的终端档位', trigger: 'change' }],
        remark: [{ max: 128, message: '最多输入128个字符', trigger: 'blur' }],
      },
      provinceOptions: [],
      levelOptions: [],
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        let _this = this

        _this.dialogAddEditViewForm = {
          provinceId: null,
          provinceName: '',
          name: '',
          sortNum: 9,
          remark: '',
          levelIdArray: [],
          levelNameArray: [],
          levelIds: '',
          levelNames: ''
        }

        if (_this.eventType !== 'view') {
          _this.loadProvinceData()
        }

        if (_this.eventType !== 'add') {
          _this.loadMarketReportLevelGroupData()
        }

        _this.$nextTick(() => {
          _this.$refs.dialogAddEditViewForm.clearValidate()
        })
      }
    }
  },
  methods: {
    // 加载数据
    loadMarketReportLevelGroupData() {
      let _this = this
      viewMarketReportLevelGroupApi({ id: _this.dataId }).then((response) => {
        const { data } = response
        for (let key in _this.dialogAddEditViewForm) {
          if (!data[key]) continue
          _this.dialogAddEditViewForm[key] = data[key]
        }
        data.levelIds.split(',').forEach(item => {
          _this.dialogAddEditViewForm.levelIdArray.push(Number(item))
        })
        data.levelNames.split(',').forEach(item => {
          if (item) {
            _this.dialogAddEditViewForm.levelNameArray.push(item)
          }
        })
        _this.dialogAddEditViewForm.id = data.id
        if (_this.eventType !== 'view') {
          _this.loadLevelData(data.provinceId);
        }

      })
    },
    // 获取省区下拉数据
    loadProvinceData() {
      let _this = this;
      _this.provinceOptions = [];
      listAreaApi({ parentId: 1, isUserArea: 1 }).then((response) => {
        const { data } = response;
        data.forEach(item => {
          _this.provinceOptions.push({ label: item.name, value: item.id })
        })
      })
    },
    // 选择省区回调
    handleProvinceChange(val) {
      let _this = this;
      let selectItem = {}
      selectItem = _this.provinceOptions.find(item => {
        return item.value === val
      })
      _this.dialogAddEditViewForm.provinceName = selectItem ? selectItem.label : ''
      if (val) {
        _this.loadLevelData(val)
      }
    },
    // 获取终端档位数据集合
    loadLevelData(provinceId) {
      let _this = this;
      listStoreLevelSettingApi({ provinceId: provinceId }).then((response) => {
        const { data } = response;
        _this.levelOptions = data || [];
      })
    },

    // 新增|修改保存
    handleSave() {
      let _this = this
      _this.$refs.dialogAddEditViewForm.validate(valid => {
        if (valid) {
          _this.$confirm((_this.eventType === 'add' ? '是否确定新增' : '是否确定修改') + '市场报告档位分组', '系统提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning', center: true })
            .then(async () => {
              let levelIdArray = _this.dialogAddEditViewForm.levelIdArray.sort((a, b) => a - b);
              _this.dialogAddEditViewForm.levelIds = levelIdArray.join(',');
              let levelNameArray = [];
              levelIdArray.forEach(item => {
                let storeLevel = _this.levelOptions.find(levelItem => levelItem.id === item);
                levelNameArray.push(storeLevel.name)
              })
              _this.dialogAddEditViewForm.levelNames = levelNameArray.join(',')

              saveMarketReportLevelGroupApi(_this.dialogAddEditViewForm).then(() => {
                _this.$message({ message: '保存成功', type: 'success' })
                _this.$emit('reloadData')
                _this.modalClose()
              }).catch(() => { })
            }).catch(() => { })
        }
      })
    },
    modalClose() {
      let _this = this
      _this.$emit('update:dialogVisible', false)
      _this.$refs.dialogAddEditViewForm.clearValidate()
    },
  }
}
</script>
<style lang="scss"  scoped>
.el-checkbox-group {
  .el-col {
    min-height: 28px;
    padding: 5px;
  }
}

::v-deep .el-checkbox-button__inner {
  width: 100%;
}

.level-tag {
  .el-col {
    min-height: 28px;
    padding: 5px;
  }
}
</style>
